import Layout from '@/components/Layout';
import { Typography, Box, Container } from '@mui/material';
import Head from 'next/head';
import LongTerm from '@/components/longterm';

const LongtermInvestmentAnalysis = () => {
  return <>
    <Layout>
      <Head>
        <title>Longterm Investment Analysis</title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 6,
          mt: 6
        }}
      >
        <Container maxWidth="lg">
          <Box mb={3}>
            <Typography variant='h3' component="h1" align='center'>Longerm Investment Analysis</Typography>
          </Box>
          <LongTerm />
        </Container>
      </Box>
    </Layout>
  </>
}

export default LongtermInvestmentAnalysis;